const message = {
  selectedTextAdvanced: "Selected",
  pleaseSelect: "Please Select",
  pleaseInput: "Please Input",
  search: "Search",
  maxSelectedCount: "Select up to {count}",
  customTime: "Custom Time",
  monthly: "Monthly",
  weekly: "Weekly",
  all: "All",
  items: "Items",
  selectAll: "Select {label}",
};

export default message;
